import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

import { ExpenseDraftRouter } from './expense-draft/_router'
import { HotelRouter } from './hotel/_router'
import { CrewWageRouter } from './wage/_router'

const Index = lazy(() => import('./Index'))
const ProfileIndex = lazy(() => import('./profile/Index'))
const BillingIndex = lazy(() => import('./billing/Index'))
const CalendarIndex = lazy(() => import('./calendar/Index'))
const PlanningIndex = lazy(() => import('./planning/Index'))
const LinkedFlightsIndex = lazy(() => import('./linked-flights/Index'))
const FlightWishesIndex = lazy(() => import('./flight-wishes/Index'))
const ShareholderRequestsIndex = lazy(() => import('./shareholder-requests/Index'))
const VolunteerIndex = lazy(() => import('./volunteer/Index'))
const AttestationsIndex = lazy(() => import('./attestations/Index'))
const TimeIndex = lazy(() => import('./time/Index'))
const FileSharingIndex = lazy(() => import('./file-sharing/Index'))

export const DashboardRouter = React.memo(() => (
  <SubRouter loggedIn>
    <Route path='profile/*' element={<ProfileIndex />} />
    <Route path='expense-draft/*' element={<ExpenseDraftRouter />} />
    <Route path='wage/*' element={<CrewWageRouter />} />
    <Route path='hotel/*' element={<HotelRouter />} />
    <Route path='billing/*' element={<BillingIndex />} />
    <Route path='calendar/*' element={<CalendarIndex />} />
    <Route path='planning/*' element={<PlanningIndex />} />
    <Route path='linked-flights/*' element={<LinkedFlightsIndex />} />
    <Route path='flight-wishes/*' element={<FlightWishesIndex />} />
    <Route path='shareholder-requests/*' element={<ShareholderRequestsIndex />} />
    <Route path='volunteer/*' element={<VolunteerIndex />} />
    <Route path='attestations/*' element={<AttestationsIndex />} />
    <Route path='time/*' element={<TimeIndex />} />
    <Route path='file-sharing/*' element={<FileSharingIndex />} />
    <Route path='*' element={<Index />} />
  </SubRouter>
))
